// Imports for external libraries go here.
import React, { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this link.
import { ButtonBannerProps } from './ButtonBanner.types';
import { StyledButtonBanner } from './ButtonBanner.styles';
import { Button } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { EditableComponent } from '@adobe/aem-react-editable-components';

// Use named rather than default exports.
export const ButtonBanner: FC<ButtonBannerProps> = props => {
  return (
    <StyledButtonBanner data-testid="luxury-ButtonBanner" data-component-name="m-luxury-ButtonBanner">
      <div className={clsx('button-container d-flex justify-content-center align-items-center', props?.styleclass)}>
        {props?.buttonMultifield?.map(link => (
          <Button
            href={link?.linkPathType === 'link' ? link?.linkUrl : link?.fileReferenceImage}
            rel={link?.openInANewTab || link?.fileReferenceImage ? 'noopener noreferrer' : ''}
            target={link?.openInANewTab || link?.fileReferenceImage ? '_blank' : '_self'}
            custom_click_track_value={link?.clickTrackValue}
            isLink={true}
            ariaLabel={link?.linkText}
            className={clsx(
              'custom_click_track',
              link?.ctaType === 'primaryButton' && 'm-button-primary d-flex align-items-center p-3',
              link?.ctaType === 'secondaryButton' && 'm-button-secondary d-flex align-items-center p-3',
              link?.ctaType === 'tertiaryLink' && 'py-3 pl-4 pr-0 ml-md-4 text-center d-flex align-items-center',
              link?.ctaType === 'tertiaryLink' &&
                (link?.openInANewTab || link?.fileReferenceImage
                  ? 'm-link-tertiary-button-external'
                  : 'm-link-tertiary-button'),
              link?.ctaType === 'textLink' && 'text-link m-link pb-0 pt-2 text-center',
              link?.ctaType === 'textLink' &&
                (link?.trailingIcon || link?.openInANewTab || link?.fileReferenceImage) &&
                'm-link-tertiary-button-external',
              (link?.ctaType === 'primaryButton' || link?.ctaType === 'secondaryButton') && {
                'm-button-l px-4': props?.buttonSize === 'large',
                'm-button-m': props?.buttonSize === 'medium',
                'm-button-s': props?.buttonSize === 'small',
              }
            )}
          >
            {(link?.ctaType === 'primaryButton' ||
              link?.ctaType === 'secondaryButton' ||
              link?.ctaType === 'tertiaryLink') &&
              link?.leadingIcon && (
                <span
                  className={clsx(
                    'd-flex mr-2',
                    link?.leadingIcon,
                    props?.buttonSize === 'large' ? 'icon-l' : 'icon-s'
                  )}
                />
              )}
            <span className="link-text">{link?.linkText}</span>
            {(link?.ctaType === 'primaryButton' || link?.ctaType === 'secondaryButton') && link?.trailingIcon && (
              <span
                className={clsx('icon-arrow-right d-flex ml-2', props?.buttonSize === 'large' ? 'icon-l' : 'icon-s')}
              />
            )}
          </Button>
        ))}
      </div>
    </StyledButtonBanner>
  );
};

export const ButtonBannerConfigs = {
  emptyLabel: 'ButtonBanner',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/button-banner/v1/button-banner`,
};

export const ButtonBannerEditable = (props: ButtonBannerProps) => (
  <EditableComponent config={ButtonBannerConfigs} {...props}>
    <ButtonBanner {...props} />
  </EditableComponent>
);
